import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export default function SEO({
  title,
  description,
  keywords,
  canonical,
  robots,
  author,
  publisher,
  schema
}) {
  const location = useLocation();

  return (
    <Helmet key={location.pathname}>
      {/* Title */}
      {title && <title>{title}</title>}

      {/* Description */}
      {description && (
        <meta name="description" content={description} />
      )}

      {/* Keywords */}
      {keywords && (
        <meta name="keywords" content={keywords} />
      )}

      {/* Canonical */}
      {canonical && (
        <link rel="canonical" href={canonical} />
      )}

      {/* Robots */}
      {robots && (
        <meta name="robots" content={robots} />
      )}

      {/* Author */}
      {author && (
        <meta name="author" content={author} />
      )}

      {/* Publisher */}
      {publisher && (
        <meta name="publisher" content={publisher} />
      )}

      {/* Schema */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
